/* ==========================================================================
   Interactive size guide (IN / CM toggle)

   Data transcribed from the 2026 size-guide artwork and verified by cropping
   every table region out of the source PNGs and grouping them by pixel hash:
   17 guides collapse to 4 distinct measurement sets + 1 shared inseam/height
   table. See DATA_AUDIT.md in the rollout notes.

   A product is matched to its guide by the FILENAME of the image already
   assigned to its custom.size_guide metafield, so a product always gets the
   interactive version of the exact guide it shows today. Anything unmatched
   falls through to the existing image lightbox.
   ========================================================================== */
(function () {
  'use strict';

  var STORE_KEY = 'kw-size-unit';

  /* ---------- measurement sets ---------- */

  var STANDARD = {
    in: [
      ['26"', '28 - 28.5', '36.5 - 37.5', '26.5 - 27'],
      ['28"', '30 - 30.5', '38.5 - 39.5', '27.5 - 28'],
      ['30"', '32 - 32.5', '40.5 - 41.5', '28.5 - 29'],
      ['32"', '34 - 34.5', '42.5 - 43.5', '29.5 - 30'],
      ['34"', '36 - 36.5', '44.5 - 45.5', '30.5 - 31'],
      ['36"', '38 - 38.5', '46.5 - 47.5', '31.5 - 32'],
      ['38"', '40 - 40.5', '48.5 - 49.5', '32.5 - 33'],
      ['40"', '42 - 42.5', '50.5 - 51.5', '33 - 33.5'],
      ['42"', '44 - 44.5', '52.5 - 53.5', '33.5 - 34.3'],
      ['44"', '46 - 46.5', '54 - 55', '34.5 - 35']
    ],
    cm: [
      ['26"', '71.1 - 72.4', '92.7 - 95.3', '67.3 - 68.6'],
      ['28"', '76.2 - 77.5', '97.8 - 100', '69.8 - 71.1'],
      ['30"', '81.3 - 82.6', '103 - 105', '72.4 - 73.7'],
      ['32"', '86.4 - 87.6', '108 - 110', '74.9 - 76.2'],
      ['34"', '91.4 - 92.7', '113 - 116', '77.5 - 78.7'],
      ['36"', '96.5 - 97.8', '118 - 121', '80 - 81.3'],
      ['38"', '101.6 - 102.9', '123 - 126', '82.5 - 83.8'],
      ['40"', '106.7 - 108', '128 - 131', '83.8 - 85.1'],
      ['42"', '111.8 - 113', '133 - 136', '85.1 - 87'],
      ['44"', '116.8 - 118', '137 - 140', '87.6 - 88.9']
    ]
  };

  // Old Skool Chinos + Epik Chill.
  // CORRECTION (approved by Jonathan 2026-07-29): the 32" waist (cm) reads
  // "85.1 - 81.3" in the source artwork — a descending, impossible range, with
  // 81.3 copy-pasted from the 30" row's upper bound. Corrected here to
  // "85.1 - 86.4" (33.5 - 34 in), matching the precise conversion used by the
  // neighbouring rows. THE SOURCE PNGs STILL NEED THE SAME FIX.
  var CHINO = {
    in: [
      ['26"', '27.5 - 28', '36.5 - 37.5', '24.5 - 25'],
      ['28"', '29.5 - 30', '38.5 - 39.5', '25.5 - 26'],
      ['30"', '31.5 - 32', '40.5 - 41.5', '26.5 - 27'],
      ['32"', '33.5 - 34', '42.5 - 43.5', '27.5 - 28'],
      ['34"', '35.5 - 36', '44.5 - 45.5', '28.5 - 29'],
      ['36"', '37.5 - 38', '46.5 - 47.5', '29.5 - 30'],
      ['38"', '39.5 - 40', '48.5 - 49.5', '30.5 - 31'],
      ['40"', '41.5 - 42', '50.5 - 51.5', '31.5 - 32'],
      ['42"', '43.5 - 44', '52.5 - 53.5', '32.5 - 33'],
      ['44"', '45.5 - 46', '54 - 55', '33.5 - 34']
    ],
    cm: [
      ['26"', '69.8 - 71.1', '92.7 - 95.3', '62 - 64'],
      ['28"', '74.9 - 76.2', '97.8 - 100', '65 - 66'],
      ['30"', '80 - 81.3', '103 - 105', '67 - 69'],
      ['32"', '85.1 - 86.4', '108 - 110', '70 - 71'],
      ['34"', '90.2 - 91.4', '113 - 116', '72 - 74'],
      ['36"', '95.3 - 96.5', '118 - 121', '75 - 76'],
      ['38"', '100 - 102', '123 - 126', '77 - 79'],
      ['40"', '105 - 107', '128 - 131', '80 - 82'],
      ['42"', '110 - 112', '133 - 136', '83 - 84'],
      ['44"', '116 - 117', '137 - 140', '85 - 86']
    ]
  };

  // Astro K Twill: chino waist/seat, standard thigh. Carries the same 32" cm
  // correction as CHINO above.
  var TWILL = {
    in: [
      ['26"', '27.5 - 28', '36.5 - 37.5', '26.5 - 27'],
      ['28"', '29.5 - 30', '38.5 - 39.5', '27.5 - 28'],
      ['30"', '31.5 - 32', '40.5 - 41.5', '28.5 - 29'],
      ['32"', '33.5 - 34', '42.5 - 43.5', '29.5 - 30'],
      ['34"', '35.5 - 36', '44.5 - 45.5', '30.5 - 31'],
      ['36"', '37.5 - 38', '46.5 - 47.5', '31.5 - 32'],
      ['38"', '39.5 - 40', '48.5 - 49.5', '32.5 - 33'],
      ['40"', '41.5 - 42', '50.5 - 51.5', '33 - 33.5'],
      ['42"', '43.5 - 44', '52.5 - 53.5', '33.5 - 34.3'],
      ['44"', '45.5 - 46', '54 - 55', '34.5 - 35']
    ],
    cm: [
      ['26"', '69.8 - 71.1', '92.7 - 95.3', '67.3 - 68.6'],
      ['28"', '74.9 - 76.2', '97.8 - 100', '69.8 - 71.1'],
      ['30"', '80 - 81.3', '103 - 105', '72.4 - 73.7'],
      ['32"', '85.1 - 86.4', '108 - 110', '74.9 - 76.2'],
      ['34"', '90.2 - 91.4', '113 - 116', '77.5 - 78.7'],
      ['36"', '95.3 - 96.5', '118 - 121', '80 - 81.3'],
      ['38"', '100 - 102', '123 - 126', '82.5 - 83.8'],
      ['40"', '105 - 107', '128 - 131', '83.8 - 85.1'],
      ['42"', '110 - 112', '133 - 136', '85.1 - 87'],
      ['44"', '116 - 117', '137 - 140', '87.6 - 88.9']
    ]
  };

  // Flamehead === STANDARD plus an extra 24" row at the top.
  var FLAMEHEAD = {
    in: [['24"', '26 - 26.5', '34.5 - 35.5', '25.5 - 26']].concat(STANDARD.in),
    cm: [['24"', '66 - 67.6', '87.6 - 90', '64.8 - 66']].concat(STANDARD.cm)
  };

  // Shared by all 14 full-length guides. Source renders the 32" height as
  // "69 -73"; normalised to "69 - 73" here.
  var FIT = {
    in: [['28"', '64 - 66'], ['30"', '67 - 69'], ['32"', '69 - 73'], ['34"', '73 - 77']],
    cm: [['28"', '163 - 168'], ['30"', '170 - 175'], ['32"', '175 - 185'], ['34"', '185 - 196']]
  };

  /* ---------- guide registry ----------
     Matched against the size_guide image filename. Order matters: more
     specific tokens first (REFLEKTOR_JORTS before REFLEKTORS, ASTRO_K_TWILL
     before SUPREME_ASTRO_K). layout 'B' = jorts/shorts: no inseam table. */
  var GUIDES = [
    { match: 'OLD_SKOOL_CHINO',   title: 'Old Skool Chinos',  data: CHINO,     layout: 'A' },
    { match: 'MICROSUEDE_CARGOS', title: 'Microsuede Cargos', data: STANDARD,  layout: 'A' },
    { match: 'MICROSUEDE_SHORTS', title: 'Microsuede Shorts', data: STANDARD,  layout: 'B' },
    { match: 'REFLEKTOR_JORTS',   title: 'Reflektor Jorts',   data: STANDARD,  layout: 'B' },
    { match: 'GRAFFITI_JORTS',    title: 'Graffiti Jorts',    data: STANDARD,  layout: 'B' },
    { match: 'ASTRO_K_TWILL',     title: 'Astro K Twill',     data: TWILL,     layout: 'A' },
    { match: 'SUPREME_ASTRO_K',   title: 'Astro K',           data: STANDARD,  layout: 'A' },
    { match: 'SUPREME_KORDZ',     title: 'Supreme Kordz',     data: STANDARD,  layout: 'A' },
    { match: 'KING_KORDZ',        title: 'King Kordz',        data: STANDARD,  layout: 'A' },
    { match: 'MAGIC_MUSHROOM',    title: 'Magic Mushroom',    data: STANDARD,  layout: 'A' },
    { match: 'FLAMEHEAD',         title: 'Flamehead',         data: FLAMEHEAD, layout: 'A' },
    { match: 'PLANET_K',          title: 'Planet K',          data: STANDARD,  layout: 'A' },
    { match: '69ERS',             title: '69ers',             data: STANDARD,  layout: 'A' },
    { match: 'REFLEKTORS',        title: 'Reflektors',        data: STANDARD,  layout: 'A' },
    { match: 'ATOMIC',            title: 'Atomic',            data: STANDARD,  layout: 'A' },
    { match: 'EPIK_CHILL',        title: 'Epik Chill',        data: CHINO,     layout: 'A' },
    { match: 'KLOWNS',            title: 'Klowns',            data: STANDARD,  layout: 'A' }
  ];

  function resolveGuide(filename) {
    if (!filename) return null;
    var f = String(filename).toUpperCase();
    for (var i = 0; i < GUIDES.length; i++) {
      if (f.indexOf(GUIDES[i].match) !== -1) return GUIDES[i];
    }
    return null;
  }

  /* ---------- unit preference ----------
     Precedence: the shopper's own explicit choice (persisted) beats the
     country default. The country default is NOT persisted on first view, so a
     visitor who switches market later still gets that market's default until
     they actually pick a unit themselves. */
  var defaultUnit = 'in';

  function readUnit() {
    try {
      var stored = localStorage.getItem(STORE_KEY);
      if (stored === 'cm' || stored === 'in') return stored;
    } catch (e) {}
    return defaultUnit;
  }
  function writeUnit(u) {
    try { localStorage.setItem(STORE_KEY, u); } catch (e) {}
  }

  /* Every rendered copy (modal + the PDP accordion) registers here so a toggle
     in one updates the other. */
  var instances = [];
  function broadcast(u) {
    writeUnit(u);
    instances = instances.filter(function (i) { return document.contains(i.root); });
    instances.forEach(function (i) { i.apply(u); });
  }

  /* ---------- markup ---------- */
  function rows(data) {
    var html = '';
    for (var i = 0; i < data.length; i++) {
      html += '<tr>';
      for (var j = 0; j < data[i].length; j++) html += '<td>' + data[i][j] + '</td>';
      html += '</tr>';
    }
    return html;
  }

  function buildBody(guide, opts) {
    var hasFit = guide.layout === 'A';
    var unitLabel = '<span class="kw-sg-unit" data-kw-sg-unit></span>';
    var photo = '<div class="kw-sg-photo" data-layout="' + guide.layout + '" data-fit="' +
      (opts.women ? 'w' : 'm') + '"' +
      (opts.image ? ' style="background-image:url(' + opts.image + ')"' : '') +
      ' role="img" aria-label="' + guide.title + ' measurement diagram"></div>';

    return '' +
      '<h2 class="kw-sg-title">' + guide.title + ' Size Guide</h2>' +
      '<p class="kw-sg-sub">(Unisex)</p>' +
      '<div class="kw-sg-toggle-row">' +
        '<div class="kw-sg-toggle" data-unit="in" role="group" aria-label="Measurement units">' +
          '<span class="kw-sg-thumb" aria-hidden="true"></span>' +
          '<button type="button" class="kw-sg-b-in" aria-pressed="true">IN</button>' +
          '<button type="button" class="kw-sg-b-cm" aria-pressed="false">CM</button>' +
        '</div>' +
      '</div>' +
      '<div class="kw-sg-grid" data-layout="' + guide.layout + '">' +
        '<div class="kw-sg-col-left">' +
          '<table><thead><tr>' +
            '<th>Kikwear<br>Size</th>' +
            '<th>Waist ' + unitLabel + '</th>' +
            '<th>Seat ' + unitLabel + '</th>' +
            '<th>Thigh ' + unitLabel + '</th>' +
          '</tr></thead><tbody data-kw-sg-main></tbody></table>' +
        '</div>' +
        '<div class="kw-sg-col-right">' +
          (hasFit
            ? '<table><thead><tr><th>Inseam</th><th>Height ' + unitLabel + '</th></tr></thead>' +
              '<tbody data-kw-sg-fit></tbody></table>'
            : '') +
          photo +
        '</div>' +
      '</div>';
  }

  /* ---------- wiring ---------- */
  function activate(root, guide) {
    var toggle = root.querySelector('.kw-sg-toggle');
    var grid = root.querySelector('.kw-sg-grid');
    var main = root.querySelector('[data-kw-sg-main]');
    var fit = root.querySelector('[data-kw-sg-fit]');
    var bIn = root.querySelector('.kw-sg-b-in');
    var bCm = root.querySelector('.kw-sg-b-cm');
    var unit = readUnit();

    function paint(u) {
      var label = u === 'cm' ? '(CM)' : '(Inches)';
      var labels = root.querySelectorAll('[data-kw-sg-unit]');
      for (var i = 0; i < labels.length; i++) labels[i].textContent = label;
      main.innerHTML = rows(guide.data[u]);
      if (fit) fit.innerHTML = rows(FIT[u]);
    }

    function apply(u, instant) {
      unit = u;
      toggle.setAttribute('data-unit', u);
      bIn.setAttribute('aria-pressed', String(u === 'in'));
      bCm.setAttribute('aria-pressed', String(u === 'cm'));
      if (instant) { paint(u); return; }
      grid.classList.add('is-swapping');
      setTimeout(function () {
        paint(u);
        grid.classList.remove('is-swapping');
      }, 130);
    }

    bIn.addEventListener('click', function () { if (unit !== 'in') broadcast('in'); });
    bCm.addEventListener('click', function () { if (unit !== 'cm') broadcast('cm'); });

    instances.push({ root: root, apply: apply });
    apply(unit, true); // initial render only — deliberately does not persist
  }

  /* ---------- modal ---------- */
  var overlay = null;
  var lastFocus = null;

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openModal(guide, opts) {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'kw-sg-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.innerHTML = '<div class="kw-sg-modal">' +
        '<button type="button" class="kw-sg-close" aria-label="Close size guide">&times;</button>' +
        '<div data-kw-sg-body></div></div>';
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.classList.contains('kw-sg-close')) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
      });
    }

    var body = overlay.querySelector('[data-kw-sg-body]');
    body.innerHTML = buildBody(guide, opts);
    activate(body, guide);

    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = overlay.querySelector('.kw-sg-close');
    if (closeBtn) closeBtn.focus();
  }

  /* ---------- boot ---------- */
  function boot() {
    var cfg = document.getElementById('kw-size-guide-config');
    if (!cfg) return;

    var filename = cfg.getAttribute('data-file');
    var image = cfg.getAttribute('data-image');
    var women = cfg.getAttribute('data-women') === 'true';
    // Country default, resolved server-side from localization.country.
    defaultUnit = cfg.getAttribute('data-default-unit') === 'cm' ? 'cm' : 'in';
    var guide = resolveGuide(filename);

    // No matching guide (e.g. the t-shirt chart) -> leave the existing
    // Fancybox image behaviour completely untouched.
    if (!guide) return;

    var opts = { image: image, women: women };

    // 1. Intercept the "Size Guide" links next to the size selector.
    var triggers = document.querySelectorAll('.size-guide-link, [data-ec-size-guide]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('data-kw-sg-bound', 'true');
      triggers[i].removeAttribute('data-fancybox');
      triggers[i].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal(guide, opts);
      }, true);
    }

    // 2. Replace the flat image inside the PDP size-guide accordion with the
    //    interactive tables rendered inline.
    var inlineHosts = document.querySelectorAll('[data-kw-sg-inline]');
    for (var k = 0; k < inlineHosts.length; k++) {
      var host = inlineHosts[k];
      host.innerHTML = buildBody(guide, opts);
      host.classList.add('kw-sg-inline');
      activate(host, guide);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
